import { RouteRecordRaw } from 'vue-router'

const pmsRoutes: RouteRecordRaw[] = [
  {
    path: '/pms',
    name: 'pms.index',
    component: () => import('@/modules/pms/views/PMSMainView.vue'),
    meta: {
      pageTitle: 'PMS',
      breadcrumbs: ['PMS']
    }
  },
  {
    path: '/pms/components/:id',
    name: 'pms-components.show',
    component: () => import('@/modules/pms/views/PmsComponentShowView.vue'),
    meta: {
      pageTitle: 'Component',
      breadcrumbs: ['PMS']
    }
  }
]

export default pmsRoutes
